import { z } from "zod"
import type { ColumnSizing } from "@/lib/column-widths"

export const COLUMNS = [
  "name",
  "kind",
  "email",
  "phone",
  "city",
  "country",
  "updated",
] as const

export const columnSchema = z.enum(COLUMNS)

export type Column = z.infer<typeof columnSchema>

export const DEFAULT_COLUMNS: Column[] = [...COLUMNS]

export const COLUMN_LABELS: Record<Column, string> = {
  name: "Name",
  kind: "Type",
  email: "Email",
  phone: "Phone",
  city: "City",
  country: "Country",
  updated: "Updated",
}

export type Slot = Column | "actions"

export const COLUMN_SIZING: ColumnSizing<Slot> = {
  id: "customers",
  widths: {
    name: 12,
    kind: 8,
    email: 12,
    phone: 8,
    city: 7,
    country: 7,
    updated: 7,
    actions: 3.25,
  },
  fill: "name",
  pinned: ["actions"],
  extras: ["actions"],
  dropOrder: ["updated", "kind", "city", "phone", "country"],
}

export function slotsOf(columns: Column[]): Slot[] {
  return [...columns, "actions"]
}

export function withName(columns: Column[]): Column[] {
  return COLUMNS.filter(
    (column) => column === "name" || columns.includes(column),
  )
}
